<div class="sheet">
  <div class="line">
    <h4>{{ data.title }}</h4>
    <img class="icon-xl" (click)="close()" [src]="'close.svg' | themeSource" alt="close" />
  </div>
  <textarea class="note-input" data-testid="comment-sheet-input" [placeholder]="'WAITER.ADDITIONAL_COMMENTS' | translate" [(ngModel)]="comment" maxlength="250"></textarea>
  <button class="btn" data-testid="comment-sheet-submit" (click)="submit()">
    {{ 'ACTIONS.SUBMIT' | translate }}
  </button>
</div>
